console.log('form validations ready');

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('create_customer');
  const firstName = document.getElementById('RegisterForm-FirstName');
  const firstNameError = document.getElementById('firstname-error');
  const lastName = document.getElementById('RegisterForm-LastName');
  const lastNameError = document.getElementById('lastname-error');
  const fieldBabyDate = document.getElementById('field-baby-date');
  const babyDate = document.getElementById('fecha_nacimiento');
  const babyDateError = document.getElementById('baby-date-error');
  const telefono = document.getElementById('RegisterForm-Phone');
  const telefonoError = document.getElementById('phone-error');
  const terminosCheck = document.getElementById('terminosCheck');
  const terminosCheckError = document.getElementById('register-terms-error');
  const datosCheck = document.getElementById('datosCheck');
  const datosCheckError = document.getElementById('data-error');
  const email = document.getElementById('RegisterForm-email');
  const emailError = document.getElementById('email-error');
  const passwordText = document.getElementById('RegisterForm-password');
  const passwordError = document.getElementById('password-error');
  const identificacion = document.querySelectorAll('input[name="tipo-identificacion"]');  
  const fieldCedula = document.getElementById('field-cedula');
  const fieldPasaporte = document.getElementById('field-pasaporte');
  const cedula = document.getElementById('cedula');
  const cedulaError = document.getElementById('cedula-error');
  const pasaporte = document.getElementById('pasaporte');
  const pasaporteError = document.getElementById('pasaporte-error');
  const acceptsAffiliate = document.getElementById('accepts_affiliate');
  const fieldType = document.getElementById('field-type');
  const typeParent = document.getElementById('customer-type-parent');
  const typeFamily = document.getElementById('customer-type-family');
  let hasError = false;

  console.log(document.querySelectorAll('form#create_customer input'));
  const allInputs = document.querySelectorAll('form#create_customer input');
  allInputs.forEach(input => {
    input.addEventListener('focus', function(event){
      var elementError = event.target.parentNode.querySelector('.form-error');
      if (elementError) {
        elementError.innerHTML = "";
      }
    });
  });

  identificacion.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        if (this.value == "cedula") {
          fieldCedula.classList.remove('hidden');
          cedula.value = "";
          cedulaError.innerHTML = "";
          fieldPasaporte.classList.add('hidden');
          pasaporte.value = "";
          pasaporteError.innerHTML = "";
        }
        if (this.value == "pasaporte") {
          fieldCedula.classList.add('hidden');
          cedula.value = "";
          cedulaError.innerHTML = "";
          fieldPasaporte.classList.remove('hidden');
          pasaporte.value = "";
          pasaporteError.innerHTML = "";
        } 
      }
    });
  });

  acceptsAffiliate.addEventListener('change', function() {
    if(this.checked) {
      fieldBabyDate.classList.remove('hidden');
      babyDateError.innerHTML = "";
      fieldType.classList.remove('hidden');
      typeParent.disabled = false;
      typeFamily.disabled = false;
    } else {
      fieldBabyDate.classList.add('hidden');
      babyDateError.innerHTML = "";
      fieldType.classList.add('hidden');
      typeParent.disabled = true;
      typeFamily.disabled = true;
    }
  });


  function notEmpty(value) {
    if (value.trim() === '') {
      return "Campo obligatorio."
    } else {
      return true;
    }
  }

  function clearErrors() {
    const allErrors = document.querySelectorAll('.form-error');
    hasError = false;
    for (const theError of allErrors) {
      theError.innerHTML = "";
    }
  }

  function isValidCI(ci) {
    var mensaje = "";
    var isNumeric = true;
    var total = 0, 
      individual;	

    if(ci.trim() == '') {
      mensaje = "Debe ingresar su número de cédula";
      return mensaje;
    }

    for (var position = 0 ; position < 10 ; position++) {
      // Obtiene cada posición del número de cédula
      // Se convierte a string en caso de que 'ci' sea un valor numérico
      individual = ci.toString().substring(position, position + 1)

      if(isNaN(individual)) {
        console.log(ci, position,individual, isNaN(individual))
        isNumeric=false;				
        break;			
      } else {
        // Si la posición es menor a 9
        if(position < 9) {
          // Si la posición es par, osea 0, 2, 4, 6, 8.
          if(position % 2 == 0) {
            // Si el número individual de la cédula es mayor a 5
            if(parseInt(individual)*2 > 9) {
              // Se duplica el valor, se obtiene la parte decimal y se aumenta uno 
              // y se lo suma al total
              total += 1 + ((parseInt(individual)*2)%10);
            } else {
              // Si el número individual de la cédula es menor que 5 solo se lo duplica
              // y se lo suma al total
              total += parseInt(individual)*2;
            }
          // Si la posición es impar (1, 3, 5, 7)
          }else {
            // Se suma el número individual de la cédula al total
            total += parseInt(individual);		    		
          }
        } 
      }
    }

    if((total % 10) != 0) {
      total =  (total - (total%10) + 10) - total;		
    } else {
      total = 0 ; 	
    }

    if(isNumeric) {	
      // El total debe ser igual al último número de la cédula
      console.log(ci, total, individual);
      console.log(ci, typeof ci, ci.length)
      // La cédula debe contener al menos 10 dígitos
      if(ci.toString().length != 10) { 
        mensaje = "La cédula debe ser de: 10 dígitos.";
        return mensaje; 
      }

      // El número de cédula no debe ser cero
      if (parseInt(ci, 10) == 0) { 
        mensaje = "La cédula ingresada no puede ser cero.";
        return mensaje;
      }

      // El total debe ser igual al último número de la cédula
      if(total != parseInt(individual)) { 
        mensaje = "La cédula ingresada no es válida.";
        return mensaje;
      } 

      console.log('cédula válida', ci);
      return true;			
    }

    // Si no es un número  
    mensaje = "La cédula solo puede contener numeros.";
    return mensaje;
  }

  form.addEventListener('submit', function(event) {       
    clearErrors();

    const validFirstName = notEmpty(firstName.value);
    if(validFirstName !== true) {
      firstNameError.innerHTML = validFirstName;
      hasError = true;
    }
    const validLastName = notEmpty(lastName.value);
    if(validLastName !== true) {
      lastNameError.innerHTML = validLastName;
      hasError = true;
    }

    // If cedula not hidden then validate
    if(!fieldCedula.classList.contains('hidden')) {
      const validCedula = isValidCI(cedula.value);
      if(validCedula !== true) {
        document.getElementById('cedula-error').innerHTML = validCedula;
        hasError = true;
      }
    }
    // If pasaporte not hidden then validate
    if(!fieldPasaporte.classList.contains('hidden')) {
      const validPasaporte = notEmpty(pasaporte.value);
      if(validPasaporte !== true) {
        pasaporteError.innerHTML = validPasaporte;
        hasError = true;
      }
    }
    // If date not hidden then validate
    if(!fieldBabyDate.classList.contains('hidden')) {
      const validBabyDate = notEmpty(babyDate.value);
      if(validBabyDate !== true) {
        babyDateError.innerHTML = validBabyDate;
        hasError = true;
      }      
   }
    const validTelefono = notEmpty(telefono.value);
    if(validTelefono !== true) {
      telefonoError.innerHTML = validTelefono;
      hasError = true;
    }
    if(!terminosCheck.checked) {
      terminosCheckError.innerHTML = "Campo obligatorio";
      hasError = true;
    }
    if(!datosCheck.checked) {
      datosCheckError.innerHTML = "Campo obligatorio";
      hasError = true;
    }
    const validEmail = notEmpty(email.value);
    if(validEmail !== true) {
      emailError.innerHTML = validEmail;
      hasError = true;
    }
    const validPassword = notEmpty(passwordText.value);
    if(validPassword !== true) {
      passwordError.innerHTML = validPassword;
      hasError = true;
    }

    // If there's an error then stop and scroll up
    if (hasError === true) {
      event.preventDefault();
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  });
});